export default {
  id: undefined,
  type: 'service_modifier',
  attributes: {
    amount: 0,
    duration: 0,
    equals: 'range',
    min: 0,
    max: 500,
    service_id: null,
    unit: 'sqft',
  },
}
